import { ButtonProps } from 'antd/lib/button';

import { UiButton } from '../ui-button';

type Props = {
  onClick: () => void;
  disabled?: boolean;
} & ButtonProps;

export function UiSaveButton(props: Props) {
  return (
    <UiButton
      {...props}
      htmlType="button"
      type="primary"
      disabled={props.disabled ?? false}
    >
      Сохранить
    </UiButton>
  );
}
